export const selectIntroMessages = (state) => state.introMessages;
export const selectAudioFile = (state) => selectIntroMessages(state).audioMessageFile;
export const selectIntroMessagesList = (state) =>
  selectIntroMessages(state).data.map((introMessage) => ({
    ...introMessage,
    text: introMessage.text || introMessage.originalFileName,
  }));



// WEBPACK FOOTER //
// ./redux/selectors/introMessages.js